module.exports = __webpack_public_path__ + "img/e-quip-bk.55034166.svg";